<template>
  <div v-if="visible" class="nude-slider">
    <label>{{ computedLabel }}</label>
    <g-markdown v-if="description" :content="description" />
    <div ref="sliderContainer" class="slider-container" @mousemove="moveSlide">
      <div v-if="showEmojis" class="emojis">
        <img src="@/assets/svg/emoji-sad.svg" />
        <img src="@/assets/svg/emoji-happy.svg" />
      </div>
      <div class="scale">
        <div class="min">{{ displayMin }}</div>
        <div class="max">{{ displayMax }}</div>
      </div>
      <div class="track" />
      <div
        ref="handle"
        class="handle"
        @mousedown="startSlide"
        @touchstart="startSlide"
        @touchmove="moveSlide"
      >
        <div class="handle-inner"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  props: {
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: () => ''
    },
    description: {
      type: String,
      default: () => null
    },
    displayMin: {
      type: String,
      default: '1'
    },
    displayMax: {
      type: String,
      default: '10'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    startPercentage: {
      type: Number,
      default: 0
    },
    showEmojis: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      inSlideMode: false,
      sliderPos: 0,
      handleWidth: 30
    };
  },
  computed: {
    format() {
      return {
        wide: this.wide
      };
    },
    computedLabel() {
      if (this.required) {
        return '* ' + this.label;
      } else {
        return this.label;
      }
    }
  },
  watch: {
    visible(newVal, oldVal) {
      if (newVal) {
        Vue.nextTick(() => {
          this.$emit('change', 88);
          this.initSlider();
        });
      } else {
        this.$emit('change', '');
      }
    }
  },
  mounted() {
    if (this.visible) {
      this.$emit('change', 88);
      this.initSlider();
    }
  },

  methods: {
    initSlider() {
      let absPercentage = this.startPercentage;

      const rect = this.$refs.sliderContainer.getBoundingClientRect();
      const wrapperWidth = rect.width;

      const max = wrapperWidth - this.handleWidth;
      const value = parseInt(absPercentage * max, 10) + this.handleWidth / 2;
      //console.log('value', value);
      this.sliderPos = value;

      this.$refs.handle.style.transform =
        'translateX(' + this.sliderPos + 'px)';
    },
    startSlide(evt) {
      evt.preventDefault();

      this.inSlideMode = true;
      this.sliderPos = this.getXpos(evt);
      this.$refs.handle.style.transform =
        'translateX(' + this.sliderPos + 'px)';

      window.addEventListener('touchend', this.endSlide);
      window.addEventListener('mouseup', this.endSlide);
    },
    endSlide(evt) {
      evt.preventDefault();
      window.removeEventListener('touchend', this.endSlide);
      window.removeEventListener('mouseup', this.endSlide);
      this.inSlideMode = false;

      if (evt instanceof MouseEvent) {
        this.sliderPos = this.getXpos(evt);
      }
      this.emitValue(this.sliderPos);
    },
    moveSlide(evt) {
      evt.preventDefault();
      if (!this.inSlideMode) {
        return;
      }
      this.sliderPos = this.getXpos(evt);
      this.$refs.handle.style.transform =
        'translateX(' + this.sliderPos + 'px)';
    },
    emitValue(xPos) {
      let pagePos = this.$refs.sliderContainer.getBoundingClientRect();
      let totalWidth = pagePos.width - 30;

      let value = ((xPos - 15) / totalWidth) * (this.max - this.min) + this.min;
      value = Math.round(value * 10) / 10;
      this.$emit('change', value);
    },
    getXpos(evt) {
      let xPos = 0;
      let pagePos = this.$refs.sliderContainer.getBoundingClientRect();

      if (evt instanceof MouseEvent) {
        xPos += evt.clientX;
      } else if (evt instanceof TouchEvent) {
        xPos += evt.touches[0].clientX;
      }

      return Math.max(15, Math.min(pagePos.width - 15, xPos - pagePos.x));
    }
  }
};
</script>

<style lang="scss" scoped>
$sliderWidth: 30px;

.nude-slider {
  width: 100%;
  position: relative;

  label {
    color: #202020;
    display: block;
    font-size: 18px;

    font-weight: 600;
    line-height: 23px;
    margin: 15px 0 12px 0;
  }

  .slider-container {
    width: 100%;
    padding: 10px 0 0 0;

    .emojis {
      pointer-events: none;
      display: flex;
      justify-content: space-between;
      margin-bottom: 6px;
    }

    .scale {
      pointer-events: none;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      margin-bottom: 12px;
    }

    .track {
      height: 12px;
      border-radius: 6px;
      width: 100%;
      //background-color: $green;
      background: linear-gradient(180deg, #256a52 0%, #49d0a1 100%);
    }
    .handle {
      cursor: pointer;
      height: $sliderWidth + 20px;
      width: $sliderWidth + 20px;
      margin-top: -6px;
      //pointer-events: none;
      //background-color: red;
      position: relative;
      left: -25px;
      top: -25px;

      .handle-inner {
        position: relative;
        height: $sliderWidth;
        width: $sliderWidth;
        /*    transform: translate(-50%, -50%); */
        transform: translate(10px, 10px);
        //background-color: $white;
        border-radius: 50%;
        background: linear-gradient(180deg, #266c54 0%, #4ad2a3 100%);
        display: block;
        box-shadow: 1px 1px 3px 0px $green;
        &::after {
          position: relative;
          top: 7px;
          left: 7px;
          content: '';
          display: block;
          width: 17px;
          height: 17px;
          border-radius: 50%;
          background: white;
        }
      }
    }
  }
}
</style>
